export var NewClientsDescription = 'Clients who completed their first appointment in the past 1 to 6 weeks.' +
    ' Choose the time frame that works best for you.';
export var RegularClientsDescription = 'Clients with two or more completed appointments, the latest within the past 6 weeks.';
export var LapsedClientsDescription = 'Clients with a last appointment 6 to 12 weeks ago.';
export var ProspectiveClientsDescription = 'Potential clients who haven’t booked an appointment yet.';
export var AudienceOptions;
(function (AudienceOptions) {
    AudienceOptions["ALL_CLIENTS"] = "All clients";
    AudienceOptions["CUSTOM"] = "Custom";
})(AudienceOptions || (AudienceOptions = {}));
export var ClientsCategories;
(function (ClientsCategories) {
    ClientsCategories["DEFAULT_CLIENTS"] = "Default segments";
    ClientsCategories["CLIENTS_BY_SERVICE"] = "Clients by service";
    ClientsCategories["BARBERS_CLIENTS"] = "Barbers\u2019 clients";
    ClientsCategories["SHOPS_CLIENTS"] = "Shops\u2019 clients";
})(ClientsCategories || (ClientsCategories = {}));
export var DefaultSegments;
(function (DefaultSegments) {
    DefaultSegments["NEW_CLIENTS"] = "New Clients";
    DefaultSegments["REGULAR_CLIENTS"] = "Regular Clients";
    DefaultSegments["LAPSED_CLIENTS"] = "Lapsed Clients";
    DefaultSegments["PROSPECTIVE"] = "Prospective Clients";
})(DefaultSegments || (DefaultSegments = {}));
export var NewCustomerWeeksOptions = [
    { label: '1 Week Ago', value: '1' },
    { label: '2 Weeks Ago', value: '2' },
    { label: '3 Weeks Ago', value: '3' },
    { label: '4 Weeks Ago', value: '4' },
    { label: '5 Weeks Ago', value: '5' },
    { label: '6 Weeks Ago', value: '6' },
];
